import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { Instances } from '../../../../constants';
import { IStateType } from '../../../../store/models/root.interface';
import { requestObject } from '../../../../store/Object';
import { makeSelectObjectsArray, requestObjects } from '../../../../store/Objects';
import { closeSideBar } from '../../../../store/sidebar';
import TemplateApplyForm, { DispatchPropsType, MapStateType } from '../organisms/templates/templateApplyForm';
import { getData } from '../../../../store/actions/SMSTemplates.action';

const mapStateToProps = (state: IStateType) => ({
    data: state.SMSTemplates,
    senderIdList: makeSelectObjectsArray(Instances.smsSenderId)(state),
    userProfile: state.profile
});

const mapDispatchToProps = (dispatch: any) => ({
    onClose: () => dispatch(closeSideBar()),
    onLoad: () => dispatch(requestObjects(Instances.smsTemplate)),
    onLoadData: () => dispatch(getData()),
    onSave: (applyTemplateData: any, callback: (resp: any, flag: boolean) => void) => dispatch(requestObject(Instances.smsTemplateApply, undefined, undefined, 'POST', true, true, applyTemplateData, callback)),
    onShortenUrl: (urlOb: any, callback: (resp: any, flag: boolean) => void) => dispatch(requestObject(Instances.smsTemplateUrlShortener, undefined, undefined, 'POST', true, true, urlOb, callback)),
    onFileShortener: (payload: any, callback: (resp: any, flag: boolean) => void) => dispatch(requestObject(Instances.smsTemplateFileShortener, undefined, undefined, 'POST', true, true, payload, callback)),
    onBulkUploadSave: (importData: any, callback: (resp: any, flag: boolean) => void) => dispatch(requestObject(Instances.smsBulkUpload, undefined, undefined, 'POST', true, true, importData, callback)),
});

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(TemplateApplyForm));